import { render, staticRenderFns } from "./ProtestAndPickListTabs.vue?vue&type=template&id=8c658214&"
import script from "./ProtestAndPickListTabs.vue?vue&type=script&lang=js&"
export * from "./ProtestAndPickListTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VTabsItems})
